import { InfoFilled } from "@clockwise/icons";
import { getUrlForFeature } from "@clockwise/web-commons/src/util/routes.util";
import { useRouter } from "found";
import React from "react";
import { TrackingEvents, track } from "../../util/analytics.util";

export const PlannerAIBanner = () => {
  const { router } = useRouter();

  const handleAIBannerClick = () => {
    track(TrackingEvents.AI_WEBAPP_CTA.PLANNER_BANNER_CLICKED);
    router.push(getUrlForFeature("ai", { relative: true }));
  };

  return (
    <div className="cw-flex cw-bg-busy-inset cw-gap-1 cw-py-2 cw-text-busy cw-body-base cw-font-medium cw-justify-center cw-items-center">
      <InfoFilled className="cw-fill-busy cw-w-4 cw-h-4" />
      <span>
        Planner will be retired soon. Check out{" "}
        <span
          className="cw-cursor-pointer cw-underline hover:cw-text-busy-hover"
          onClick={handleAIBannerClick}
          role="button"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleAIBannerClick();
            }
          }}
          tabIndex={0}
          aria-label="Go to AI Scheduler"
        >
          AI Scheduler
        </span>
        , your new calendar assistant.
      </span>
    </div>
  );
};
